var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'tag',
    `tag--${typeof _vm.type === 'object' ? _vm.type.id : _vm.type}`,
    _vm.small && 'tag--small',
  ]},[(!_vm.small)?_c('span',[_vm._v(_vm._s(_vm.type.libelle)),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }